import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { EntityFormControl, EntityFormGroup, EntityFormArray } from '../../models/form.types';
import { BazisFormService } from '../../services/form.service';

@Component({
    selector: 'bazis-required-mark',
    template: `<span
        color="danger"
        *ngIf="required$ | async"
        >*</span
    >`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisRequiredMarkComponent implements OnInit {
    @Input() source: EntityFormControl | EntityFormArray | EntityFormGroup;

    required$ = null;

    ngOnInit() {
        if (this.source) {
            BazisFormService.getPropertiesFromConfig(this, this.source.$config);
        }
    }
}
